import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react";
import React, { FC } from "react";
import { ErrorView } from "../ErrorView";

export const ErrorBoundary: FC = ({ children }) => (
    <SentryErrorBoundary fallback={props => <ErrorView message={props.error.message} />}>
        {children}
    </SentryErrorBoundary>
);
